import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: Removed React.StrictMode as it causes navigation issues with React Router v7
root.render(<App />);
